import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const PageResultsCountPlaceholder = () => {
  return /*#__PURE__*/_jsx(Paragraph, {
    marginBlockEnd: "400",
    minBlockSize: "24px"
  });
};
export const PageResultsCount = ({
  total,
  pageSize,
  page,
  searchCriteria,
  messageProps
}) => {
  let message;
  if (!total) {
    if (searchCriteria) {
      message = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.errors.filters.noResultsFound"
      });
    } else {
      return null;
    }
  }
  if (!message) {
    const searchTerm = (() => {
      if (searchCriteria !== null && searchCriteria !== void 0 && searchCriteria.search) {
        return searchCriteria.search;
      }
      if (searchCriteria !== null && searchCriteria !== void 0 && searchCriteria.category) {
        const {
          category
        } = searchCriteria;
        if (isValidI18nKey(`learningCenter.topFilters.cat.${category}`)) {
          return I18n.text(`learningCenter.topFilters.cat.${category}`);
        }
      }
      if (searchCriteria !== null && searchCriteria !== void 0 && searchCriteria.hubspotSoftware) {
        const {
          hubspotSoftware
        } = searchCriteria;
        if (isValidI18nKey(`learningCenter.topFilters.tools.${hubspotSoftware}`)) {
          return I18n.text(`learningCenter.topFilters.tools.${hubspotSoftware}`);
        }
      }
    })();
    const startCard = page * pageSize + 1;
    const endCard = Math.min(page * pageSize + pageSize, total);
    message = searchTerm ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "learningCenter.myLearning.paginatedSearchResultsCount",
      options: {
        startCard,
        endCard,
        cardsTotal: total,
        searchTerm
      }
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.myLearning.paginatedResultsCount",
      options: {
        startCard,
        endCard,
        cardsTotal: total
      }
    });
  }
  return /*#__PURE__*/_jsx(Paragraph, Object.assign({
    marginBlockEnd: "400"
  }, messageProps, {
    children: message
  }));
};